// does what it says on the tin
// takes a number between 0-1
// returns an integer between 0-255
export default function percentToOctal( pct ) {
	return Math.round( pct * 255 );
}